const validValueNumAndLetter = (val) => {
    return /^[A-Za-z0-9]+$/.test(val)
}
const validIp = (val) => {
    return /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/.test(val)
}
export {
    validValueNumAndLetter,
    validIp
}